<template>
    <b-form @submit="onSubmit">
        <b-row class="m-2 OTecmannotation">
            <b-col v-if="loaded === false">
                <template>
                    <div class="OTloading">
                        <div class="OTloader"></div>
                    </div>
                </template>
            </b-col>
            <b-col v-else>
                <b-row class="OTsectionHeader">
                    <b-col cols="6">
                        <h1>{{ecmResourceStrings.ttlAnnotationCaption}}</h1>
                    </b-col>
                    <b-col class="text-right OTbtnContainer" cols="6">
                        <b-button
                            type="button"
                            variant=" OTSecondary"
                            @click="$router.push('/jobs')"
                        >{{ecmResourceStrings.lblCancel}}</b-button>
                        <b-button
                            type="submit"
                            variant=" OTPrimary"
                            :disabled="$v.$invalid"
                        >{{ecmResourceStrings.lblSave}}</b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <p>{{ecmResourceStrings.txtAnnotationInfo}}</p>
                    </b-col>
                </b-row>
                
                <b-row>
                    <b-col cols="auto">
                        <otif-switch :disabled="disabled_annotation" v-model="annotationOption"></otif-switch>
                    </b-col>
                    <b-col
                        cols="auto"
                        class="OTSwitchLabelTxt "
                        v-bind:class="{isDisabledSwitch: disabled_annotation}">
                        <template v-if="annotationOption" >
                            <span class="OTSwitchLabelTxtTrue" v-bind:class="{isDisabledSwitch: disabled_annotation}">{{ecmResourceStrings.lblEnable}}
                                </span></template>
                        <template v-else  class="OTSwitchLabelTxtFalse">
                            <span class="OTSwitchLabelTxtFalse" v-bind:class="{isDisabledSwitch: disabled_annotation}">{{ecmResourceStrings.lblDisable}}</span>
                            </template>
                    </b-col>
                    <template v-if="disabled_annotation">
                        <b-col cols="12" v-if="connector_compatible== false">
                            <b-alert class="OTAlert OTAlertInformation" show>
                            <span class="ot-icon-alert-title"></span>
                            {{ecmResourceStrings.infoConnectivityType}}
                            </b-alert>
                           
                        </b-col>
                        <b-col cols="12" v-else-if="category_enabled == false">
                            <b-alert class="OTAlert OTAlertError" show>
                            <span class="ot-icon-alert-title"></span>
                            {{errorInfo}}
                            </b-alert>
                        </b-col> 
                    </template>
                </b-row>
                <template v-if="annotationOption && !disabled_annotation">
                    <b-row class="mt-3">
                        <b-col>
                            <otif-select
                                name="knowledge-bases"
                                v-bind:label="ecmResourceStrings.lblClassificationTree"
                                :description="ecmResourceStrings.txtClassificationTree"
                                v-model="taxonomy"
                                :multiple="false"
                                v-bind:placeholder="ecmResourceStrings.tipClassificationTree"
                                :values="availableKnowledgeBases"
                            ></otif-select>
                        <template v-if="taxonomy_exists" >
                        </template>
                        <template v-else >
                            <b-col cols="12">
                                    <div
                                        style="display:block;"
                                        class="invalid-feedback"
                                    >{{ecmResourceStrings.errSavedTaxonomy}} {{taxonomy}} {{ecmResourceStrings.errDoNotBelongs}}</div>
                               
                                </b-col>
                            </template>
                        </b-col>
                        <b-col cols="auto" >
                            <span class="ot-icon-move-right"></span>
                        </b-col>
                        <b-col >
                            <b-row>
                                <b-col>
                                    <otif-textInput
                                        v-bind:label="ecmResourceStrings.lblTargetProperty"
                                        v-model="target_property"
                                        :disabled="true"
                                        :description="ecmResourceStrings.txtTargetProperty"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                               <b-col>
                                   <h6 style="font-size:0.750rem">{{ecmResourceStrings.lblAnnotationOptions}}</h6>
                                   <otif-radio :values="models" v-model="annotationModel" class="OTVerticalRadio"/>
                                </b-col> 
                            </b-row>                            
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <p>
                                
                            </p>
                            
                        </b-col>
                    </b-row>
                </template>
            </b-col>
        </b-row>
    </b-form>
</template>

<script>
import { validationMixin } from "vuelidate";

import { minDate } from "@/validation/dates.js";

import { resourceMapper } from "@/utils/resourceMapper.js";
import axios from "axios";

import moment from "moment";
export default {
    mixins: [validationMixin],
    props: ["job"],

    data() {
        return {
            ecmResourceStrings: require("../../../utils/resourceECM.js"),
            disabled_annotation: true, //switch is disabled and not editable
            category_enabled:false,
            connector_compatible:false,
            taxonomy_exists:true, //false, if taxonomy was saved and deleted after it
            loaded: false,
            availableKnowledgeBases: [],
            auto_profile_id: 'true',
            profiles: [],
            errorInfo:'',
            models:[{value: 'augment', label: 'Augment', description:'RM classification attached to a document is preserved and a new classification is added if different from the attached one.'},
                    {value: 'preserve', label: 'Preserve', description:'RM classification attached to a document is preserved, any new classification is ignored.'},
                    {value: 'replace', label: 'Replace', description:'RM classifications attached to a document are removed and a new classification is added.'}]
        };
    },

    computed: {

         ...resourceMapper([{
            propertyName: "annotationOption",
            attributeName: "job_criteria.annotationOption"
        },
        {
            propertyName: "annotationModel",
            attributeName: "job_criteria.annotationModel"
        },
        {
            propertyName: 'repositoryType',
            attributeName: 'job_criteria.repositoryType'
        },
        "profile_id",
       ], 'job', 'ecm-annotation-settings'),

        taxonomy: {
            cache: false,
            get() {
                const props = this.$lodash.get(this.job.attributes, 'job_criteria.annotationList', {});
                return Object.keys(props).map((k) => {
                    return k;
                });
            },
            set(newval) {
                var obj = Object.create(null);
                obj[newval] = this.target_property;
                this.job.set('job_criteria.annotationList', obj);
                this.taxonomy_exists=true;
                this.$eventBus.$emit('section-changed', 'ecm-annotation-settings');
            }
        },
    },

    validations: {},

    components: {},

    watch: {
        disabled_annotation(newVal) {
            if (newVal === false) {
                this.$v.$reset();
            }
        },
        annotationOption(newVal) {
            if (newVal === false) {
                this.$v.$reset();
            }
        },
        taxonomy_exists(newVal){
            if (newVal === true) {
                this.$v.$reset();
            }
        },
    },

    methods: {

        onSubmit($e) {
            $e.preventDefault();
            if(this.annotationOption == false)
            {
                var obj = Object.create(null);
                this.job.set('job_criteria.annotationList', obj);
            }
            this.job.save();
        },
    },

    mounted() {

        if (this.job.attributes.profile_id) {
            this.auto_profile_id = 'false';
        }

        var breadcrumbs = [
            {
                name: "jobs",
                meta: { label: "Jobs" }
            },
            {
                name: "job-edit",
                params: { job_id: this.job.id },
                meta: { label: this.job.get("job_name") }
            },
            {
                name: "ecm-annotation-settings",
                meta: { label: "Annotation" },
                params: { job_id: this.job.id }
            }
        ];

        this.$store.commit("breadcrumbs", breadcrumbs);
    },

    async created() {
        //annotation model
        if(!this.annotationModel)
        {
            this.annotationModel='augment';
        }
        this.errorInfo=this.ecmResourceStrings.infoNoEnabledAnnotator;
        if(this.repositoryType == 'is_generic_v1')
        {
            this.connector_compatible=true;
            if (this.profile_id) 
            {
                try
                {
                    const res = await axios.get("/mtm-gateway-api/v1/services/pipeline/otca-profiles/" + this.profile_id + "/form");
                    if (res.data.requestTemplateForm) {
                        //this.profile = res.data;
                        this.category = res.data.requestTemplateForm.ncategorizer;
                        this.availableKnowledgeBases = res.data.requestTemplateForm.ncategorizer.knowledgeBases;
                        if(this.availableKnowledgeBases.length >0)
                        {
                            if (this.category.enabled == true) {
                                this.disabled_annotation = false;
                                this.category_enabled = true;
                            }
                            
                            //this.annotationOption = this.category.enabled;
                            this.target_property = "Record Management Classification";
                            if(this.taxonomy.length>0)
                            {
                            if(this.taxonomy[0])
                            {
                                const existtaxonomy = this.availableKnowledgeBases.indexOf(this.taxonomy[0]); 
                                if(existtaxonomy < 0)
                                {
                                    this.taxonomy_exists = false;
                                }
                            }
                            }
                        }
                        else
                        {
                            if (this.category.enabled == false) {
                                
                            }
                            else
                            {
                                this.errorInfo=this.ecmResourceStrings.errLoadTaxonomies;
                                //this.$snotify.error(this.ecmResourceStrings.errLoadTaxonomies);
                            }
                        }
                        this.loaded = true;
                        this.$v.$reset();
                    }
                    else
                    {
                    
                        this.loaded = true;
                        this.$v.$reset();
                    }
                } 
                catch (err)
                {
                    this.loaded = true;
                    this.$v.$reset();
                    this.$snotify.clear();
                    if (err.response)
                    {
                         if(err.response.data)
                        {
                            if(err.response.data.message)
                            {
                                this.errorInfo=err.response.data.message;
                                //this.$snotify.error(err.response.data);
                            }
                            else
                            {
                                this.errorInfo=err.response.data;
                            }
                        }
                    }
                    else if (err.message)
                    {
                        this.errorInfo=err.message;
                        //this.$snotify.error(err.message);
                    } 
                }
            }
            else {
                this.target_property = "Record Management Classification";
                this.availableKnowledgeBases=[];
                if(this.auto_profile_id == 'true')
                {
                    try
                    {
                        const res = await axios.get("/mtm-gateway-api/v1/services/pipeline/tmeValues/knowledgeBases");
                        var ooo = res.data;
                        this.availableKnowledgeBases=res.data.allowedValues; 
                        if(this.availableKnowledgeBases.length >0)
                        {
                            this.target_property = "Record Management Classification";
                            if(this.taxonomy[0])
                            {
                                const existtaxonomy = this.availableKnowledgeBases.indexOf(this.taxonomy[0]); 
                                if(existtaxonomy < 0)
                                {
                                    this.taxonomy_exists = false;
                                }
                            }
                            this.disabled_annotation = false;
                            this.category_enabled = true;
                        }
                        else
                        {
                            this.errorInfo=this.ecmResourceStrings.errLoadTaxonomies;
                            //this.$snotify.error(this.ecmResourceStrings.errLoadTaxonomies);
                        }
                        this.loaded = true;
                        this.$v.$reset();
                    }
                    catch (err)
                    {
                        this.loaded = true;
                        this.$v.$reset();
                        this.$snotify.clear();
                        if (err.response)
                        {
                            if(err.response.data)
                            {
                                if(err.response.data.message)
                                {
                                    this.errorInfo=err.response.data.message;
                                    //this.$snotify.error(err.response.data);
                                }
                                else
                                {
                                    this.errorInfo=err.response.data;
                                }
                            }
                        }
                        else if (err.message)
                        {
                            this.errorInfo=err.message;
                            //this.$snotify.error(err.message);
                        } 
                    }
                }
                this.loaded = true;
                this.$v.$reset();
            }
        }
        else
        {
            if(this.annotationOption == true)
            {
                this.annotationOption=false;
            }
            this.loaded = true;
            this.$v.$reset();
        }
    }
};
</script>

